function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgLandingConditions4 = function SvgLandingConditions4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 329 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_18186_115858)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 269.488,
    cy: 148.073,
    rx: 204.449,
    ry: 166.158,
    transform: "rotate(7.1284 269.488 148.073)",
    fill: "#FF3586"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "difference"
    },
    filter: "url(#filter1_f_18186_115858)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 262.418,
    cy: 119.771,
    rx: 185.88,
    ry: 109.04,
    transform: "rotate(-105 262.418 119.771)",
    fill: "#00904A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    filter: "url(#filter2_f_18186_115858)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 274.172,
    cy: 227.273,
    rx: 121,
    ry: 70.5,
    fill: "#FFAA00"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_18186_115858",
    x: 0.458595,
    y: -83.8656,
    width: 538.059,
    height: 463.88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32.55,
    result: "effect1_foregroundBlur_18186_115858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_18186_115858",
    x: 69.4977,
    y: -139.108,
    width: 385.841,
    height: 517.755,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 38.55,
    result: "effect1_foregroundBlur_18186_115858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_18186_115858",
    x: 88.0719,
    y: 91.6734,
    width: 372.2,
    height: 271.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32.55,
    result: "effect1_foregroundBlur_18186_115858"
  }))));
};
export default SvgLandingConditions4;